<template>
  <div class="product header-90">

    <div class="product-main">
      <div class="product-conten productDetails-conten">
        <div class="product-title pc_hide ">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em> /  </em>
            <router-link :to="'/Product/' + detailData.typeId" >{{ detailData.kindName }}</router-link>
          <em> /</em>
          <span>{{ detailData.name }}</span>
        </div>
        <div>
          <div class="imgBigShow">
            <div class="imageBig">
              <img :src="showImg" width="100%" alt="">
            </div>
            <div class="imageSmall mobile_hide" v-if="detailData.minImage">
              <img :src="detailData.minImage" width="100%" alt="">
            </div>
          </div>
          <div class="Details-Text">
            <div class="product-title mobile_hide">
              <router-link to="/home">{{$t("home_0")}}</router-link>
              <em> /  </em>
             <router-link :to="'/Product/' + detailData.typeId" >{{ detailData.kindName }}</router-link>
              <em> /</em>
              <span>{{ detailData.name }}</span>
            </div>
            <h4 :class="{'en_h4':locale=='EN'}">{{ detailData.name }}</h4>
            <span class="volume" v-if="detailData.ingredient">{{ detailData.ingredient }}</span>
            <div class="composition mobile_hide" v-if="detailData.protein && detailData.fat && detailData.carbohydrate">
              <ul>
                <li>
                  <div class="text-content">
                    <span>{{$t('home_51')}}</span>
                    <span>{{ detailData.protein }}</span>
                  </div>
                </li>
                <li>
                  <i class="left-line"></i>
                  <div class="text-content">
                    <span>{{$t('home_52')}}</span>
                    <span>{{ detailData.fat }}</span>
                  </div>
                  <i class="right-line"></i>
                </li>
                <li>
                  <div class="text-content">
                    <span>{{$t('home_53')}}</span>
                    <span>{{ detailData.carbohydrate }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <p class="describe mobile_hide">{{ detailData.describe }}</p>
            <div class="container-box">
              <div class="swiper-container" id="productMoreImg">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item,index) in detailData.imageFileDtoList" :key="index" @click="clickSwiperImage(index)">
                    <div @click="updateShowImg(item.imageUrl)">
                      <img :src="item.imageUrl" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-next" id="product-more-img-next"></div>
              <div class="swiper-button-prev" id="product-more-img-prev"></div>
            </div>
            <p class="describe pc_hide">{{ detailData.describe }}</p>
            <div class="composition pc_hide" v-if="detailData.protein || detailData.fat || detailData.carbohydrate">
              <ul>
                <li>
                  <div class="text-content">
                    <span>{{$t("home_51")}}</span>
                    <span>{{ detailData.protein }}</span>
                  </div>
                </li>
                <li>
                  <i class="left-line"></i>
                  <div class="text-content">
                    <span>{{$t("home_52")}}</span>
                    <span>{{ detailData.fat }}</span>
                  </div>
                  <i class="right-line"></i>
                </li>
                <li>
                  <div class="text-content">
                    <span>{{$t("home_53")}}</span>
                    <span>{{ detailData.carbohydrate }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="potstickers">
          <h5 :class="{'reset-margin':detailData.kindNameEN == detailData.kindName}">{{ detailData.kindNameEN }}</h5>
          <div class="tileLine" v-if="detailData.kindNameEN != detailData.kindName">
            <i ></i>
            <h6 :class="{'en_h6':locale=='EN'}">{{ detailData.kindName }}</h6>
          </div>
          <div class="container-box potstickers-box">
            <div class="swiper-container"  id="productListImg">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in productList" :key="index" @click="toDetail(item.id)">
                  <section>
                    <div class="img-box-by-list">
                      <div class="big-img">
                        <img :src="item.maxImage" alt="">
                      </div>
                      <div class="small-img mobile_hide" v-if="item.minImage">
                        <img :src="item.minImage" alt="">
                      </div>
                    </div>
                    <h3> {{ item.name }} </h3>
                  </section>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="swiper-button-next" id="product-list-img-next"></div>
            <div class="swiper-button-prev" id="product-list-img-prev"></div>
          </div>

        </div>
      </div>
      <div class="visit-cord">
          <div class="left-img">
            <img src="../assets/images/Visit-left.png" alt="">
          </div>
          <div class="visit-box-bg">
            <div class="visit-box">
              <h6 :class="{'en_h6':locale=='EN'}">{{$t("home_54")}}</h6>
              <ul>
                <li v-for="(item, index) in cacheProductList2" :key="index">
                  <span :class="{'en_span':locale=='EN'}">{{ item.name }}</span>
                  <span>
                    <a @click="toDetail(item.id)">{{$t("home_55")}}</a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api";

  export default {
    data(){
      return{
        swiperIndex: 0,
        showImg: '',
        locale:'tw',
        detailData: {
          imageFileDtoList: []
        },
        cacheProductList: [],
        cacheProductList2: [],
        productList: [],
        foodImage:[{
          bigImage: '../assets/images/product-01.png',
          smallImage: '../assets/images/product2.png'
        },{
          bigImage: '../assets/images/product-02.png',
          smallImage: '../assets/images/product2.png'
        },{
          bigImage: '../assets/images/product-03.png',
          smallImage: '../assets/images/product2.png'
        },{
          bigImage: '../assets/images/product-04.png',
          smallImage: '../assets/images/product2.png'
        },{
          bigImage: '../assets/images/product-05.png',
          smallImage: '../assets/images/product2.png'
        },{
          bigImage: '../assets/images/product-06.png',
          smallImage: '../assets/images/product2.png'
        }]
      }
    },
    mounted() {
      this.locale=sessionStorage.getItem('lang')
      this.GetDetail(this.$route.params.id);
    },
    methods: {
      clickSwiperImage(index){
        this.swiperIndex = index;
      },
      toDetail: function (id){
        this.$router.push({ name: 'ProductDetails', params: { id: id }});
        this.GetDetail(id);
        document.documentElement.scrollTop = 0;
      },
      GetDetail:function(id){
        this.$fetch(`${API.getProductDetail}?Id=${id}`).then((response) => {
          if(response.code === 200){
            this.detailData = response.data;
            this.showImg = this.detailData.maxImage;
            this.$nextTick(() => {
              this.initProductSwiper();
            });
            this.getCache();
            this.getProductList(this.detailData.typeId);
          }
        });
      },
      getProductList:function(id){
        this.$post(API.getProductList,{
          "typeId": id
        }).then((response) => {
          if(response.code === 200){
            this.productList = response.data;
            this.$nextTick(() => {
              this.initProductListSwiper();
            });
          }
        });
      },
      initProductSwiper(){
        const swiper = new Swiper('#productMoreImg', {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '#product-more-img-next',
            prevEl: '#product-more-img-prev',
          },
          breakpoints: {
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 3,
              spaceBetween: 10
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
          }
        });
      },
      initProductListSwiper(){
        const swiper = new Swiper('#productListImg', {
          slidesPerView: 1,
          spaceBetween: 10,
           pagination: {
             el: '.swiper-pagination',
             clickable: true,
           },
          navigation: {
            nextEl: '#product-list-img-next',
            prevEl: '#product-list-img-prev',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 64,
            },
          }
        });
      },
      getCache: function (){
        const language = sessionStorage.getItem('lang');
        const cacheProductList = localStorage.getItem('product' + language);
        if (cacheProductList){
          this.cacheProductList = JSON.parse(cacheProductList);
          this.cacheProductList2 = JSON.parse(cacheProductList).reverse();
        }
        this.setCache();
      },
      setCache: function (){
        const cacheProductListString = JSON.stringify(this.cacheProductList);
        const hasCache = cacheProductListString.includes(this.detailData.id);
        console.log(hasCache)
        const language = sessionStorage.getItem('lang');
        if (!hasCache){
          if(this.cacheProductList.length >= 6){
            this.cacheProductList.splice(0, 1);
          }
          this.cacheProductList.push(this.detailData);
          localStorage.setItem('product' + language, JSON.stringify(this.cacheProductList));
        }
      },
      updateShowImg(url){
        this.showImg = url;
      }
    },

  };
</script>
<style scoped lang="scss">
ul {
  padding: 0;
}

.product {
  width: 100%;
  height: auto;

  .product-main {
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-detail-bg.png") no-repeat center 40px;
    background-size: 100% auto;;
    overflow: hidden;
    padding-top: 50px;

    .product-conten {
      max-width: 1420px;
      padding: 0 20px;
      margin: 65px auto 0;

      .product-title {
        padding-bottom:20px;
        font-size: 14px;
        letter-spacing: 1.5px;
        text-align: left;
        a {
          color: #000;
          text-decoration: underline;
        }

        .no-line{
          color: #9A928D;
          text-decoration:none;
        }
        em {
          padding: 0 4px;
        }

        span, em {
          color: #9A928D;
        }
      }
    }
  }
}

.productDetails-conten {
  .imgBigShow {
    width: 42%;
    height: 100%;
    position: relative;
    float: left;

    .imageBig {
      width: 100%;
      border-radius: 50%;
      border: 10px solid #fff;
      overflow: hidden;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      img {
        width: 100%;
        height: 100%;
        background-size: 100%;
      }
    }

    .imageSmall {
      position: absolute;
      right: -6.0344%;
      bottom: 12%;
      width: 20.6869%;
      border-radius: 50%;
      border: 7px solid #fff;
      overflow: hidden;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
        background-size: 100%;
      }
    }
  }

  .Details-Text {
    width: 58%;
    height: auto;
    float: left;
    padding-left: 8.5%;
    padding-top: 55px;

    h4 {
      color: #1C2024;
      font-size: 36px;

      margin-bottom: 4px;
      font-weight: 500;
      letter-spacing: 1.69px;
    }
    .en_h4{
      font-weight: 900;
      letter-spacing: 0;
    }
    .volume {
      color: #3B240F;
      font-size: 18px;
      padding-top: 9px;
      display: block;
      letter-spacing: 1.35px;
    }

    .composition {
      width: 100%;
      height: auto;
      overflow: hidden;
      max-width: 600px;
      padding-top:44px;
      ul {
        li {
          width: 33.3%;
          height: auto;
          float: left;
          padding:0 15px;
          position: relative;
          text-align: center;
          .text-content{
            display: inline-block;
            text-align: left;
          }
          &:first-child{
            text-align: left;
            width: 23%;
            padding-left:0;
          }
          span {
            color: #000;
            display: block;
            font-size: 16px;
            letter-spacing: 1.2px;
            &:nth-child(1) {
              span {
                margin-bottom: 5px;
              }
            }
            &:nth-child(2) {
              span {
                font-family: Roboto;
              }
            }
          }
          i{
            box-sizing: border-box;
            height: 25px;
            width: 1px;
            background: #979797;
            display: block;
            position: absolute;
            top: 50%;
            margin-top: -13px;
            &.left-line{
              left:0;
            }
            &.right-line{
              right: 0;
            }
          }
        }
      }

      .line {
        display: inline-block;
        width: 85%;
        display: inline-block;

      }
    }

    .describe {
      padding: 35px 0 40px;
      color: #2F1E14;
      font-size: 18px;
      letter-spacing: 1px;
      line-height: 32px;
    }
  }

  .container-box {
    width: 78%;
    padding: 0 50px;
    position: relative;

    #productMoreImg {
      padding: 15px 0;

      .swiper-slide div {
        transition: all .25s ease-in-out;

        &:hover {
          transform: translateY(-15px);
        }
      }
    }

    .swiper-slide div {
      border-radius: 50%;
      overflow: hidden;
      border: solid 4px #fff;
      cursor: pointer;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    }

    .swiper-button-next {
      position: absolute;
      right: 0;
    }

    .swiper-button-prev {
      position: absolute;
      left: 0;
    }
    .swiper-button-disabled{
      display: none;
    }
  }

  .potstickers {
    padding-top: 180px;
    width: 100%;
    height: auto;
    clear: both;
    text-align: center;
    h5 {
      transform: rotate(360deg);
      font-size: 40px;
      font-style: italic;
      font-weight: 900;
      letter-spacing: -0.5px;
      margin-bottom: 5px;
      font-family: "Roboto Black Italic";
      &.reset-margin{
        margin-bottom: 63px;
      }
    }

    .tileLine {
      padding: 10px 0 63px 0;

      h6 {
        transform: rotate(360deg);
        display: inline-block;
        margin-left: 30px;
        font-size: 40px;
        letter-spacing: 3.33px;
      }
      .en_h6{
        font-size: 28px;
        letter-spacing: 0;
      }
      i {
        box-sizing: border-box;
        height: 2px;
        width: 102px;
        display: inline-block;
        background: #000;
        vertical-align: text-top
      }
    }

    .potstickers-box {
      width: 100%;
      max-width: 1300px;
      height: auto;
      margin: 0 auto;
      padding: 0 90px;

      .swiper-container {
        padding-bottom: 85px;

        .swiper-slide {
          cursor: pointer;

          .img-box-by-list{
            border: none;
            position: relative;
            overflow: visible;
          }
          section {
            position: relative;
          }

          .big-img {
            width: 100%;
            border-radius: 50%;
            border: 8px solid #fff;
            position: relative;
          }

          .small-img {
            width: 30%;
            position: absolute;
            bottom: 16px;
            right: 0;
            border-radius: 50%;
            overflow: hidden;
            border: solid 4px #fff;
            background: #fff;

            img {
              width: 100%;
            }
          }

          h3 {
            color: #000;
            font-size: 18px;
            letter-spacing: 1px;
            line-height: 32px;
            margin: 20px 0 0;
            padding-right: 10%;
            text-align: center;
          }
        }
      }

      .swiper-button-next, .swiper-button-prev {
        margin-top: -82px;
      }
    }
  }

}

#productListImg {
  padding-top: 40px;

  .swiper-slide {
    transition: transform .3s ease-in-out;
  }

  .swiper-slide-active {
    transform: translateY(-40px);
  }

  .swiper-slide-next {
    & + .swiper-slide {
      & + .swiper-slide {
        transform: translateY(-40px);
      }
    }
  }
}

.visit-cord {
  width: 100%;
  height: 100%;
  background: #D00717 url(../assets/images/Visit-recordBG.png) no-repeat center top;
  background-size: 100%;
  margin-top: 20px;

  .left-img {
    position: absolute;
    margin-top: -63px;
  }

  .visit-box-bg{
    background: url(../assets/images/Visit-right.png) no-repeat right bottom;
    background-size: 100% 100%;
  }
  .visit-box {
    max-width: 1350px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    padding-bottom: 230px;
    position: relative;
    h6 {
      transform: rotate(360deg);
      color: #FFFFFF;
      font-size: 40px;
      text-align: center;
      padding-top: 201px;
      padding-bottom: 90px;
      letter-spacing: 3.33px;
      display: block;
    }
    .en_h6{
      letter-spacing: 0;
    }
    ul {
      overflow: hidden;
      li {
        max-width: 350px;
        width: calc((100% - 268px) / 3);
        min-height: 72px;
        display: table;
        border-radius: 36px;
        background-color: #FFFFFF;
        margin: 0 45px 63px;
        padding: 0 20px;
        line-height: 1.3;
        float: left;
        span {
          color: #000000;
          font-size: 20px;
          display: table-cell;
          vertical-align: middle;
          letter-spacing:1px;
          text-align: left;
          padding:20px 0;
        }
        .en_span{
          font-size: 18px;
          letter-spacing: 0;
        }
        a {
          color: #908782;
          font-size: 16px;
          float: right;
          text-decoration: underline;
          cursor: pointer;
          word-break: keep-all;
        }
      }
    }
  }
}


@media (max-width: 1080px) {
  .product {
    .product-main {
      overflow: visible;
      background-image: url("../assets/images/product-bg-mobile.png");
      padding-bottom: 0 !important;
      .product-conten {
        padding: 0;
        margin-top: 12px;
      }
    }
  }
  #productListImg .swiper-slide-next+.swiper-slide+.swiper-slide{
    transform: none !important;
  }
  .productDetails-conten .potstickers .potstickers-box .swiper-button-next, .productDetails-conten .potstickers .potstickers-box .swiper-button-prev{
    margin-top: -52px;
  }
  .productDetails-conten .Details-Text .describe{
    text-align: center;
  }
  .productDetails-conten .Details-Text .composition{
    margin: 0 auto;
  }
  .productDetails-conten {
    padding: 0 20px;
    padding-top: 47px;

    .Details-Text {
      width: 100%;
      padding: 0;

      h4 {
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        padding-top: 24px;
        margin-bottom: 0;
      }
      .volume {
        font-size: 14px;
        text-align: center;
      }

      .describe {
        font-size: 15px;
        padding: 10px 0 30px 0;
        letter-spacing: 0.5px;
        line-height: 28px;
      }

      .composition {
        padding-top: 12px;
        ul {
          li {
            width: 37.3%;
            &:first-child{
              width: 31.3%;
              padding-left: 0;
            }
            &:last-child{
              width: 31.3%;
              padding-right: 0;
            }
          }
        }
      }
    }

    .imgBigShow {
      width: 100%;
      margin-top: 15px;
      padding: 0 24px;
      .imageBig{
        width: 100%;
        border-width: 6px;
      }
    }

    .potstickers {
      padding-top: 80px;
      .potstickers-box{
        padding: 0 50px;
        .swiper-container {
          .swiper-slide{
            h3{
              padding: 0;
              margin-top: 18px;
            }
          }
        }
      }
      .swiper-button-next,.swiper-button-prev{
        width: 42px;
        height: 42px;
        background-size: 100%;
      }
      h5 {
        font-size: 22px;
      }

      .tileLine {
        padding: 0;
        margin-bottom: 30px;

        i {
          width: 30px;
          vertical-align: middle;
        }

        h6 {
          font-size: 22px !important;
          margin-left: 6px;
        }
      }
    }

    .container-box {
      width: 100%;
    }
  }
  .visit-cord {
    padding-bottom: 80px;
    width: calc(100% + 40px);
    margin-left: -20px;
    .left-img {
      display: none;
    }
    .visit-box-bg{
      background: none;
    }
    .visit-box {
      width: 100%;

      padding: 0 38px;

      h6 {
        padding-top: 60px;
        font-size: 22px;
        padding-bottom: 34px;
      }

      ul {
        li {
          max-width: 100%;
          width: 100%;
          margin-left: 0;
          margin-bottom: 29px;

          span {
            font-size: 18px;
          }
        }
      }
    }
  }
  #productListImg {
    padding-top: 0;
    padding-bottom: 35px;
    .swiper-slide-active {
      transform: translateY(0);
    }
  }
  .swiper-pagination{
    display: none;
  }
  .productDetails-conten .potstickers h5.reset-margin{
    margin-bottom: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/productDetails.vue